import createSelector from 'lib/web/createSelector'
import config from 'constants/config'

export const reserveForZeroEnabled = createSelector(
  (state: App.State) => state.auth.account.isSpoofed,
  (state: App.State) => state.config.experiments[config.AB_TEST_RESERVE_FOR_ZERO],
  (isSpoofed, experimentValue) => experimentValue === '1' || isSpoofed,
)
